import { lazy, useContext } from 'react';
import { Route } from 'react-router-dom';
import RequireAuth from '../components/routing/RequireAuth';
import IdentityContext from '../contexts/IdentityContext';
import { useRoutes } from '../hooks/useRoutes';
import Results from '../pages/material/results';
import SubModuleSelector from '../pages/material/sub-module-selector';
import Toc from '../pages/material/toc';
import TeacherAssignments from '../pages/my-assignments';
import StudentAssignments from '../pages/my-assignments/student';
import MyGroups from '../pages/my-groups';
import MyMethods from '../pages/my-methods';
import MyProfile from '../pages/my-profile';
import MyTeachers from '../pages/my-teachers';
import { withSuspense } from '../utils/suspense';

const MaterialDataProvider = lazy(() => import('../pages/material/_contexts/MaterialDataProvider'));
const AppLayoutIanua = lazy(() => import('../AppLayout.ianua'));

function useIanuaRouter() {
  const { identity } = useContext(IdentityContext);
  const { isTeacherAlike } = identity;
  const { getRoute } = useRoutes();

  return (
    <Route path="/ianua">
      <Route element={withSuspense(AppLayoutIanua)}>
        <Route element={<RequireAuth />}>
          <Route path={getRoute('MY_METHODS')} element={<MyMethods />} />
          <Route path={getRoute('MY_PROFILE')} element={<MyProfile />} />

          {!isTeacherAlike && <Route path={getRoute('MY_TEACHERS')} element={<MyTeachers />} />}

          {isTeacherAlike && <Route path={getRoute('MY_GROUPS')} element={<MyGroups />} />}

          <Route path={getRoute('MATERIAL')} element={withSuspense(MaterialDataProvider)}>
            {/** submodule selector if applicable or redirect */}
            <Route index element={<SubModuleSelector />} />
            {/** toc level for selected module (eg: super or sub module) */}
            <Route path={getRoute('MATERIAL.TOC')} element={<Toc />} />
            {/** results view for super module */}
            {isTeacherAlike && <Route path={getRoute('MATERIAL.RESULTS')} element={<Results />} />}
            <Route
              path={getRoute('MATERIAL.ASSIGNMENTS')}
              element={isTeacherAlike ? <TeacherAssignments /> : <StudentAssignments />}
            />
            <Route path={getRoute('MATERIAL.CATEGORICAL')} element={<h2>Categorical material</h2>} />
            <Route path={getRoute('MATERIAL.SEARCH')} element={<h2>Search</h2>} />
          </Route>
        </Route>
      </Route>
    </Route>
  );
}

export default useIanuaRouter;
